import React, { useContext, useMemo } from 'react';
import { Box, CloseButton, Flex, Link, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react';
import { AuthContext } from 'context/AuthContext';
import { useAppDispatch, useAppSelector } from 'Hooks';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
import { setHideCompleteSignupSection } from 'store/slices';

export const CompleteSignupPrompt = () => {
	const navigate = useLocalizedNavigate();
	const dispatch = useAppDispatch();
	const auth = useContext(AuthContext);

	const { hideCompleteSignupSection, userInfo } = useAppSelector((state) => state.authUser);
	
	const handleHideCompleteSignupSection = () => {
		dispatch(setHideCompleteSignupSection(true));
	};

	const incompleteFields = useMemo(() => {
		if (!userInfo) return [];

		const fields = [];
		
		if (!userInfo.dateOfBirth || userInfo.dateOfBirth === '0001-01-01T00:00:00') {
			fields.push('Date of Birth');
		}
		
		if (!userInfo.emailConfirmed) {
			fields.push('Email Address Confirmation');
		}
		
		if (!userInfo.age || userInfo.age === 0) {
			fields.push('Age');
		}
		
		if (!userInfo.fullName || userInfo.fullName.trim() === '') {
			fields.push('Full Name');
		}
		
		if (!userInfo.gender || userInfo.gender === 0) {
			fields.push('Gender');
		}
		
		if (!userInfo.phoneNumber || userInfo.phoneNumber.trim() === '') {
			fields.push('Phone Number');
		}
		
		return fields;
	}, [userInfo]);

	const itemsToDisplay = incompleteFields.slice(0, 2);

	if (hideCompleteSignupSection || auth.isFullyRegisteredUser()) {
		return null;
	}

	return (
		<Box
			backgroundColor={'extraLightCoral'}
			textAlign={'center'}
			py={4}
			px={['5', null, 6, '20']}
			fontSize={['10px', '14px']}
		>
			<CloseButton
				height={['13px', '20px']}
				fontSize={'9px'}
				float={'right'}
				onClick={handleHideCompleteSignupSection}
			/>
			<Stack spacing={3}>
				<Text>You still have pending item(s) to complete sign up</Text>
				
				<Flex justifyContent={'center'} alignItems={'flex-start'}>
					<UnorderedList textAlign={'left'} spacing={1}>
						{itemsToDisplay.map((item, index) => (
							<ListItem key={index}>{item}</ListItem>
						))}
						{incompleteFields.length > 2 && (
							<ListItem>...and {incompleteFields.length - 2} more</ListItem>
						)}
					</UnorderedList>
				</Flex>
				
				<Flex justifyContent={'center'} alignItems={'center'} wrap={'wrap'} gap={2}>
					<Text>
						Completing will unlock the full functionality of Loop, including clearing points earned and allowing withdrawal
					</Text>
					<Link
						fontWeight={'400'}
						color='darkCoral'
						cursor={'pointer'}
						onClick={() => {
							navigate(AppRoutes.register);
						}}
						textDecoration={'underline'}
						_hover={{ textDecoration: 'none' }}
					>
						Complete Sign Up
					</Link>
				</Flex>
				
				
			</Stack>
		</Box>
	);

};
